import {
  EmployeeIdentificationType,
  EmploymentPeriodStatusEnum,
  EmploymentViewModelNew,
  FokParameterType,
  MarkupNew,
  MarkupStatusEnum,
} from '@fora-monorepo/employer-my-pages-common/types';

import { fakePeopleData } from './fakePeopleData';

const mockEmploymentsDefault: EmploymentViewModelNew[] = [
  {
    foraAgreementNumber: '00000000004010000083',
    policyNumber: '50000000999',
    employee: {
      partnerNumberIndividual: '0032695394',
      employeeId: '195201050191',
      identificationType: EmployeeIdentificationType.PersonalIdentityNumber,
      firstName: 'Miles',
      lastName: 'John',
      address: {
        streetAddress: 'Street address',
        streetAddress2: '',
        postalCode: '11111',
        city: 'Stockholm',
        countryCode: 'SE',
      },
      birthDate: '',
      deathDate: '',
      isVerified: true,
    },
    employmentPeriods: [
      {
        employmentStartDate: '2019-01-01',
        employmentEndDate: '2024-12-10',
        markups: [
          {
            faGroupId: '0000039883',
            fokId: 'FOK567890',
            fokText: 'FOK567890 - Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
            startDate: '2019-01-01',
            endDate: '2024-12-10',
            status: MarkupStatusEnum.Active,
          },
        ],
        employmentStatus: EmploymentPeriodStatusEnum.Active,
        fokParameterChoices: [
          {
            parameterValue: FokParameterType.AvtalspensionSAFLOAfter65,
            startDate: '2021-12-31',
            endDate: '2025-12-31',
          },
        ],
      },
    ],
    activeMarkup: {
      faGroupId: '0000039883',
      fokId: 'FOK567890',
      fokText: 'FOK567890 - Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
      startDate: '2019-01-01',
      endDate: null,
      fokParameterChoices: [
        {
          parameterValue: FokParameterType.AvtalspensionSAFLOAfter65,
          startDate: '2021-12-31',
          endDate: '2025-12-31',
        },
      ],
      fokIsExpiring: null,
      status: MarkupStatusEnum.Active,
    },
    hasFokParameterChoices: true,
    isInactive: true,
    isTerminated: true,
    isFuture: false,
  },
  {
    foraAgreementNumber: '00000000004010000083',
    policyNumber: '00000500000003304',
    employee: {
      address: {
        city: 'London',
        coAddress: '',
        postalCode: 'PH14 2HB',
        countryCode: 'GB',
        streetAddress: '68 Emerson Road',
        streetAddress2: '',
      },
      lastName: 'Hall',
      birthDate: '1976-12-04',
      deathDate: null,
      firstName: 'Kieran',
      employeeId: '197612642392',
      identificationType: EmployeeIdentificationType.CoOrdinationNumber,
      partnerNumberIndividual: '7000001647',
      isVerified: false,
    },
    employmentPeriods: [
      {
        employmentStartDate: '2023-06-01',
        employmentEndDate: null,
        markups: [
          {
            faGroupId: '0000039882',
            fokId: 'FOK000374',
            endDate: '2023-07-01',
            fokText: 'FOK000374 - Arbetare - Kollektivavtal Hemserviceföretag',
            startDate: '2023-06-01',
            // fokParameterChoices: [],
            status: MarkupStatusEnum.Active,
          },
          {
            faGroupId: '0000039885',
            fokId: 'FOK000466',
            endDate: null,
            fokText: 'FOK000466 - Arbetare - Kollektivavtal Hästskötare',
            startDate: '2023-07-02',
            // fokParameterChoices: [],
            status: MarkupStatusEnum.Active,
          },
        ],
        fokParameterChoices: [],
        employmentStatus: EmploymentPeriodStatusEnum.Active,
      },
    ],
    activeMarkup: {
      faGroupId: '0000039882',
      fokId: 'FOK301151',
      endDate: null,
      fokText: 'FOK000374 - Arbetare - Kollektivavtal Hemserviceföretag',
      startDate: '2023-06-01',
      fokIsExpiring: null,
      fokParameterChoices: [],
      status: MarkupStatusEnum.Active,
    },
    hasFokParameterChoices: false,
    isInactive: true,
    isTerminated: false,
    isFuture: true,
  },
  {
    foraAgreementNumber: '00000000004010000083',
    policyNumber: '5000077777',
    employee: {
      partnerNumberIndividual: '0032695395',
      employeeId: '197010632391',
      identificationType: EmployeeIdentificationType.CoOrdinationNumber,
      firstName: 'Pamela',
      lastName: 'Sharp',
      address: {
        streetAddress: 'Street address',
        streetAddress2: '',
        postalCode: '11111',
        city: 'Stockholm',
        countryCode: 'SE',
      },
      birthDate: '',
      deathDate: '',
      isVerified: false,
    },
    employmentPeriods: [
      {
        employmentStartDate: '2019-01-01',
        employmentEndDate: null,
        markups: [
          {
            faGroupId: '0000039883',
            fokId: 'FOK567890',
            fokText: 'FOK567890 - Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
            startDate: '2019-01-01',
            endDate: null,
            status: MarkupStatusEnum.Active,
          },
        ],
        employmentStatus: EmploymentPeriodStatusEnum.Active,
        fokParameterChoices: [
          {
            parameterValue: FokParameterType.KPAfter65,
            startDate: '2021-12-31',
            endDate: null,
          },
          {
            parameterValue: FokParameterType.AvtalspensionSAFLOAfter65,
            startDate: '2021-12-31',
            endDate: null,
          },
        ],
      },
    ],
    activeMarkup: {
      faGroupId: '0000039883',
      fokId: 'FOK567890',
      fokText: 'FOK567890 - Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
      startDate: '2019-01-01',
      endDate: null,
      fokParameterChoices: [
        // {
        //   parameterValue: FokParameterType.KPAfter65,
        //   startDate: '2021-12-31',
        //   endDate: '2025-12-31',
        // },
        {
          parameterValue: FokParameterType.AvtalspensionSAFLOAfter65,
          startDate: '2021-12-31',
          endDate: null,
        },
      ],
      status: MarkupStatusEnum.Active,
      fokIsExpiring: '2023-10-29',
    },
    hasFokParameterChoices: true,
    isInactive: false,
    isTerminated: false,
    isFuture: false,
  },
  {
    foraAgreementNumber: '00000000004010000083',
    policyNumber: '50000777234',
    employee: {
      partnerNumberIndividual: '0032695395',
      employeeId: '195510632391',
      identificationType: EmployeeIdentificationType.CoOrdinationNumber,
      firstName: 'Bert',
      lastName: 'Knutsson',
      address: {
        streetAddress: 'Street address',
        streetAddress2: '',
        postalCode: '11111',
        city: 'Stockholm',
        countryCode: 'SE',
      },
      birthDate: '',
      deathDate: '',
      isVerified: true,
    },
    employmentPeriods: [
      {
        employmentStartDate: '2019-01-01',
        employmentEndDate: '2025-02-15',
        markups: [
          {
            faGroupId: '0000039883',
            fokId: 'FOK567890',
            fokText: 'FOK567890 - Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
            startDate: '2019-01-01',
            endDate: '2025-01-01',
            status: MarkupStatusEnum.Active,
          },
          {
            faGroupId: '0000039881',
            fokId: 'FOK300881',
            fokText: 'FOK300881 - Arbetare Kollektivavtal Plåt- och Ventilationsavtalet',
            startDate: '2025-01-02',
            endDate: '2025-02-15',
            status: MarkupStatusEnum.Active,
          },
        ],
        employmentStatus: EmploymentPeriodStatusEnum.Active,
        fokParameterChoices: [],
      },
      {
        employmentStartDate: '2025-02-16',
        employmentEndDate: '2025-06-16',
        markups: [
          {
            faGroupId: '0000039881',
            fokId: 'FOK300881',
            fokText: 'FOK300881 - Arbetare Kollektivavtal Plåt- och Ventilationsavtalet',
            startDate: '2025-02-16',
            endDate: '2025-06-16',
            status: MarkupStatusEnum.Active,
          },
        ],
        employmentStatus: EmploymentPeriodStatusEnum.Future,
        fokParameterChoices: [],
      },
      {
        employmentStartDate: '2025-06-17',
        employmentEndDate: '2025-07-16',
        markups: [
          {
            faGroupId: '0000039881',
            fokId: 'FOK300881',
            fokText: 'FOK300881 - Arbetare Kollektivavtal Plåt- och Ventilationsavtalet',
            startDate: '2025-06-17',
            endDate: '2025-07-16',
            status: MarkupStatusEnum.Active,
          },
        ],
        employmentStatus: EmploymentPeriodStatusEnum.Future,
        fokParameterChoices: [],
      },
    ],
    activeMarkup: {
      faGroupId: '0000039883',
      fokId: 'FOK567890',
      fokText: 'FOK567890 - Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
      startDate: '2019-01-01',
      endDate: '2025-02-15',
      fokParameterChoices: [
        {
          parameterValue: FokParameterType.KPAfter65,
          startDate: '2021-12-31',
          endDate: '2025-12-31',
        },
        {
          parameterValue: FokParameterType.AvtalspensionSAFLOAfter65,
          startDate: '2021-12-31',
          endDate: null,
        },
      ],
      status: MarkupStatusEnum.Active,
      fokIsExpiring: null,
    },
    hasFokParameterChoices: true,
    isInactive: false,
    isTerminated: false,
    isFuture: false,
  },
  {
    foraAgreementNumber: '00000000004010000083',
    policyNumber: '00000500000005031',
    employee: {
      employeeId: '200011010907',
      identificationType: EmployeeIdentificationType.PersonalIdentityNumber,
      partnerNumberIndividual: '7000000948',
      firstName: 'Test',
      lastName: 'Tosca Test Individual 98778',
      birthDate: '2000-11-01',
      deathDate: null,
      isVerified: false,
      address: {
        coAddress: '',
        streetAddress: '',
        streetAddress2: '',
        postalCode: '11360',
        city: 'Stockholm',
        countryCode: 'SE',
      },
    },
    employmentPeriods: [
      {
        employmentStartDate: '2023-01-01',
        employmentEndDate: '2024-12-31',
        markups: [
          {
            faGroupId: '0000039884',
            fokId: 'FOK300869',
            fokText: 'FOK300869 Sjöfolk - Kollektivavtal Stors',
            startDate: '2023-01-01',
            endDate: '2023-11-01',
            status: MarkupStatusEnum.Expired,
          },
          {
            faGroupId: '0000039881',
            fokId: 'TAG700100',
            fokText: 'TAG700100 Anställd kvarstående i Avtalsp',
            startDate: '2023-11-01',
            endDate: '2024-12-31',
            status: MarkupStatusEnum.Expired,
          },
        ],
        employmentStatus: EmploymentPeriodStatusEnum.Expired,
        fokParameterChoices: [],
      },
    ],
    activeMarkup: null,
    hasFokParameterChoices: false,
    isInactive: true,
    isTerminated: true,
    isFuture: false,
  },
];

const mockEmploymentsLong = fakePeopleData.map((p, i): EmploymentViewModelNew => {
  let employeeId = '';
  let identificationType = EmployeeIdentificationType.PersonalIdentityNumber;
  if (typeof p.id === 'string') {
    if (p.id.length === 13) {
      employeeId = `${p.id.slice(0, 8)}${p.id.slice(9, 13)}`;
    } else {
      employeeId = p.id;
    }
  } else {
    identificationType = EmployeeIdentificationType.CoOrdinationNumber;
    employeeId = p.id.toString();
  }
  const endDate = i % 20 === 0 ? '2023-03-11' : '2026-05-11';
  const status = i % 20 === 0 ? MarkupStatusEnum.Expired : MarkupStatusEnum.Active;
  const markup: MarkupNew = {
    faGroupId: '0000039884',
    fokId: p.fok,
    fokText: p.markup,
    startDate: '2022-01-01',
    // every twentieth person is inactive
    endDate,
    status,
  };
  const fokParameterChoices =
    i % 3 === 0 // every thrid person has param
      ? [
          {
            parameterValue: FokParameterType.KPAfter65,
            startDate: '2021-12-31',
            endDate: '2024-12-31',
          },
          {
            parameterValue: FokParameterType.AvtalspensionSAFLOAfter65,
            startDate: '2021-12-31',
            endDate: '2024-12-31',
          },
        ]
      : [];

  return {
    foraAgreementNumber: '00000000004010000083',
    policyNumber: '5000000010' + i,
    employee: {
      partnerNumberIndividual: '0032695311', //Id will be the same for all entries, add random later if needed
      employeeId,
      identificationType,
      firstName: p.firstname,
      lastName: p.lastname,
      address: {
        streetAddress: 'Street address',
        streetAddress2: '',
        postalCode: '11111',
        city: 'Stockholm',
        countryCode: 'SE',
      },
      birthDate: '',
      deathDate: '',
      isVerified: true,
    },
    employmentPeriods: [
      {
        employmentStartDate: '2022-01-01',
        employmentEndDate: endDate,
        employmentStatus: EmploymentPeriodStatusEnum.Active,
        markups: [markup],
        fokParameterChoices: fokParameterChoices || [],
      },
    ],
    activeMarkup:
      status === MarkupStatusEnum.Active
        ? { ...markup, fokIsExpiring: null, status: MarkupStatusEnum.Active, fokParameterChoices }
        : null,
    hasFokParameterChoices: true,
    isInactive: false,
    isTerminated: false,
    isFuture: false,
  };
});
const mockEmploymentsLongNoParams = fakePeopleData.map((p, i): EmploymentViewModelNew => {
  let employeeId = '';
  if (typeof p.id === 'string') {
    if (p.id.length === 13) {
      employeeId = `${p.id.slice(0, 8)}${p.id.slice(9, 13)}`;
    } else {
      employeeId = p.id;
    }
  } else {
    employeeId = p.id.toString();
  }
  return {
    foraAgreementNumber: '00000000004010000083',
    policyNumber: '5000000010' + i,
    employee: {
      partnerNumberIndividual: '0032695322', //Id will be the same for all entries, add random later if needed
      employeeId,
      identificationType: EmployeeIdentificationType.PersonalIdentityNumber,
      firstName: p.firstname,
      lastName: p.lastname,
      address: {
        streetAddress: 'Street address',
        streetAddress2: '',
        postalCode: '11111',
        city: 'Stockholm',
        countryCode: 'SE',
      },
      birthDate: '',
      deathDate: '',
      isVerified: false,
    },
    employmentPeriods: [
      {
        employmentStartDate: '2022-01-01',
        employmentEndDate: null,
        employmentStatus: EmploymentPeriodStatusEnum.Active,
        markups: [
          {
            faGroupId: '0000039884',
            fokId: p.fok,
            fokText: p.markup,
            startDate: '2022-01-01',
            endDate: null,
            status: MarkupStatusEnum.Active,
          },
        ],
        fokParameterChoices: [],
      },
    ],
    activeMarkup: {
      faGroupId: '0000039884',
      fokId: p.fok,
      fokText: p.markup,
      startDate: '2022-01-01',
      endDate: null,
      fokIsExpiring: null,
      fokParameterChoices: [],
      status: MarkupStatusEnum.Active,
    },
    hasFokParameterChoices: false,
    isInactive: false,
    isTerminated: false,
    isFuture: false,
  };
});
export const mockEmployments = {
  default: mockEmploymentsDefault,
  long: mockEmploymentsLong,
  longNoParams: mockEmploymentsLongNoParams,
  none: [],
};
